import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import './style.scss';

const TicketSkeleton = ({ children, className, dark }) => (
  <div className={`P-ticket-skeleton ${dark ? 't-s-dark' : ''} ${className || ''}`}>
    {children}

    {_.range(12).map((num) => (
      <svg
        key={num}
        xmlns="http://www.w3.org/2000/svg"
        height="9"
        viewBox="0 0 29 9"
        fill="none"
        className="ticket-bottom-polygon"
      >
        <path d="M11.6141 8.03283C13.3255 9.21651 15.5911 9.21651 17.3025 8.03283L28.9167 0H0L11.6141 8.03283Z" />
      </svg>
    ))}
  </div>
);

TicketSkeleton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  dark: PropTypes.bool,
};

export default TicketSkeleton;
